import {
	LOGIN_USER,
	LOGIN_SUCCESS,
	LOGOUT_USER,
	LOGOUT_USER_SUCCESS,
	API_ERROR,
	SOCIAL_LOGIN,
	START_TOKEN_WATCHER
} from './actionTypes';

export const loginUser = (user, history) => {
	return {
		type: LOGIN_USER,
		payload: { user, history }
	};
};

export const loginSuccess = user => {
	return {
		type: LOGIN_SUCCESS,
		payload: user
	};
};

export const logoutUser = history => {
	return {
		type: LOGOUT_USER,
		payload: { history }
	};
};

export const logoutUserSuccess = () => {
	return {
		type: LOGOUT_USER_SUCCESS,
		payload: {}
	};
};

export const apiError = error => {
	return {
		type: API_ERROR,
		payload: error
	};
};

export const socialLogin = (type, history) => {
	return {
		type: SOCIAL_LOGIN,
		payload: { type, history }
	};
};

export const setUserDataFromLocalStorage = userData => {
	return {
		type: 'SET_USER_DATA_FROM_LOCAL_STORAGE',
		payload: userData
	};
};

export const startTokenWatcher = () => ({ type: START_TOKEN_WATCHER });
